var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback } from 'react';
import { useBlock, BlockType, SavingIndicator, useBlockEdit } from '../../';
import { LazyLoadPlaceholder, } from '../../../';
import { BlockText } from '../BlockText';
import { BlockImage } from '../BlockImage';
import { BlockNew } from '../BlockNew';
export var BlockInner = memo(function (_a) {
    var id = _a.id;
    var data = useBlockEdit().blockEdit.data;
    var block = useBlock(id).block;
    var getBlock = useCallback(function (b) {
        switch (b._type) {
            case BlockType.TEXT:
                return React.createElement(BlockText, __assign({}, b));
            case BlockType.IMAGE:
                return React.createElement(BlockImage, __assign({}, b));
            default:
                return React.createElement(BlockNew, __assign({}, b));
        }
    }, []);
    if (!block)
        return React.createElement(LazyLoadPlaceholder, null);
    return (React.createElement(React.Fragment, null,
        getBlock(__assign(__assign({}, block), data)),
        React.createElement(SavingIndicator, null)));
});
